var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-box"},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }